import AttachmentUpload from 'components/attachment-upload'
import Button from 'components/button'
import ColorPicker from 'components/color-picker'
import ColorPickerV2 from 'components/color-picker-v2'
import EditableImage from 'components/editable-image'
import FileUpload from 'components/file-upload'
import BasicInput from 'components/form/basic-input'
import CheckboxInput from 'components/form/checkbox-input'
import DisplayInput from 'components/form/display-input'
import RadioGroup from 'components/form/radio-group'
import RangeInput from 'components/form/range-input'
import SelectInput from 'components/form/select-input'
import Switchinput from 'components/form/switch-input'
import HeaderSm from 'components/headers/sm'
import SearchDropDown from 'components/search-dropdown'
import { Select } from 'components/select'
import SelectDropDown from 'components/select-dropdown'
import TextEditor from 'components/text-editor'
import TextArea from 'components/textarea'
import DatePicker from 'components/form/datepicker';
import type { FunctionalComponent } from 'vue'
import { SelectBox } from 'components/selectbox'
import type { FormFieldComponentLookup } from '../field'
import { ButtonGroup } from 'components/button-group'
import { MultiSelect } from 'components/multi-select'
import RichSwitchInput from 'components/form/rich-switch-input'
import { MultiFileUpload } from 'components/multi-fileupload'

export const getComponent = (key: string | null | undefined | FunctionalComponent<any>, lookup?: FormFieldComponentLookup): any => {
  if (typeof key === 'function') return key;

  if (typeof key === 'string' && lookup && lookup[key]) return lookup[key];

  switch (key) {
    case 'multi-select':
    case 'multiselect':
    case 'multiSelect': return MultiSelect;
    case 'currency':
    case 'number':
    case 'text':
    case 'string':
    case 'password':
    case 'value':
    case 'email':
      return BasicInput
    case 'textarea':
    case 'text-area':
      return TextArea
    case 'select2':
      return Select
    case 'select':
      return SelectInput
    case 'select-dropdown':
      return SelectDropDown
    case 'search-dropdown':
      return SearchDropDown
    case 'display':
      return DisplayInput
    case 'header':
      return HeaderSm
    case 'date':
      return DatePicker
    case 'checkbox':
      return CheckboxInput
    case 'bool':
    case 'switch':
    case 'boolean':
      return Switchinput
    case 'rich-switch':
      return RichSwitchInput
    case 'radioGroup':
    case 'radio-group':
      return RadioGroup
    case 'button':
      return Button
    case 'image':
      return EditableImage
    case 'file-upload':
    case 'file':
      return FileUpload
    case 'file-drop':
      return MultiFileUpload
    case 'attachment':
    case 'attachment-upload':
      return AttachmentUpload
    case 'color-picker':
      return ColorPicker
    case 'color-picker-v2':
      return ColorPickerV2
    case 'text-editor':
      return TextEditor
    case 'range':
      return RangeInput
    case 'selectbox':
    case 'select-box':
      return SelectBox;
    case 'button-group':
    case 'buttonGroup':
      return ButtonGroup;
    default:
      return (props: any) => <input {...props} />
  }
}
